import { render, staticRenderFns } from "./CustomerAddressesTab.vue?vue&type=template&id=61838c1e&scoped=true&"
import script from "./CustomerAddressesTab.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressesTab.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAddressesTab.vue?vue&type=style&index=0&id=61838c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61838c1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
